import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
let ColorConverterService = /*#__PURE__*/(() => {
  class ColorConverterService {
    static convertDecimalToRgb(integerColor) {
      const r = integerColor >> 16 & 255;
      const g = integerColor >> 8 & 255;
      const b = integerColor & 255;
      return `rgb(${r},${g},${b})`;
    }
    static convertDecimalToRgba(integerColor, alpha) {
      const r = integerColor >> 16 & 255;
      const g = integerColor >> 8 & 255;
      const b = integerColor & 255;
      return `rgba(${r},${g},${b}, ${alpha})`;
    }
    static {
      this.luminance = color => {
        let colors;
        if (color.search('rgb') >= 0) {
          const colorRGB = color.trim().replace('rgba', '').replace('rgb', '').replace('(', '').replace(')', '').split(',').map(item => parseInt(item, 10));
          colors = {
            red: colorRGB[0],
            green: colorRGB[1],
            blue: colorRGB[2]
          };
        } else {
          color = color.replace(/^\s*#|\s*$/g, '');
          // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
          if (color.length === 3) {
            color = color.replace(/(.)/g, '$1$1');
          }
          colors = {
            red: parseInt(color.slice(0, 2), 16),
            green: parseInt(color.slice(2, 4), 16),
            blue: parseInt(color.slice(4, 6), 16)
          };
        }
        for (const i in colors) {
          if (colors.hasOwnProperty(i)) {
            let c = colors[i] / 255;
            if (c < 0.03928) {
              c = c / 12.92;
            } else {
              c = (c + .055) / 1.055;
              c = Math.pow(c, 2.4);
            }
            colors[i] = c;
          }
        }
        return colors.red * .2126 + colors.green * .7152 + colors.blue * .0722;
      };
    }
    static {
      this.ɵfac = function ColorConverterService_Factory(t) {
        return new (t || ColorConverterService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ColorConverterService,
        factory: ColorConverterService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ColorConverterService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ColorConverterService };
